import React, { FC, useContext, useEffect, useState } from 'react';

import { TableBody } from '@material-ui/core';

import { useAssignResultsState } from '../../../../../Common/AssignResults/Context/AssignResults.context';
import { TeamStrokeTableRow } from './TeamsStrokeTableRow';
import { GlobalContext } from '../../../../../../../../store';
import { ScoreType } from '../../../../../../../../store/admin/eventFormats/store';
import { useLeaderboardsResults } from '../../../../../../../common/Hooks/useLeaderboardsResults';
import { IAdminTeamResult } from '../../../../../../../../store/admin/teamResults/store';
import { useRouteInfoState } from '../../../../../../../../components/RouteInfo/Context/RouteInfo.context';

const TeamStrokeTableBody: FC = () => {
  const { clubId, eventId, roundId } = useRouteInfoState();
  const { selectedCombination, selectedTeamFormat, selectedRoundFormat } = useAssignResultsState();

  const {
    actions: {
      adminTeamHoleResults: { get: getAdminTeamHoleResults },
      adminTeamResults: { get: getAdminTeamResults }
    },
    adminTeamResults,
    adminTeamHoleResults
  } = useContext(GlobalContext);

  useEffect(() => {
    getAdminTeamHoleResults(roundId);
  }, [roundId]);

  const [selectedScoreType, setSelectedScoreType] = useState<ScoreType>();
  const [selectedFlightId, setSelectedFlightId] = useState<number>();
  const [formatIsStableford, setFormatIsStableford] = useState(false);

  const [sortedResults, formattedTeamsHoleResults] = useLeaderboardsResults({
    adminTeamHoleResults,
    adminTeamResults,
    formatIsStableford,
    roundId: Number(roundId),
    selectedFlightId,
    selectedScoreType,
    selectedTeamFormat
  });

  useEffect(() => {
    if (selectedRoundFormat) {
      setFormatIsStableford(selectedRoundFormat.scoringFormat === 1);
    }
  }, [selectedRoundFormat]);

  useEffect(() => {
    if (!!roundId) {
      getAdminTeamResults('round', roundId);
    }
  }, [roundId]);

  useEffect(() => {
    if (!!selectedCombination && !!selectedCombination.flight) {
      setSelectedFlightId(selectedCombination.flight.id);
      setSelectedScoreType(selectedCombination.scoreType);
    }
  }, [selectedCombination]);

  return sortedResults.length > 0 ? (
    <TableBody className="results-table-table-body">
      {sortedResults.map((result: IAdminTeamResult, index: number) => (
        <TeamStrokeTableRow
          key={`${index}-${result.flightId}`}
          result={result}
          roundId={Number(roundId)}
          clubId={Number(clubId)}
          eventId={Number(eventId)}
          selectedScoreType={selectedScoreType}
          formattedTeamsHoleResults={formattedTeamsHoleResults}
        />
      ))}
    </TableBody>
  ) : (
    <></>
  );
};

export default TeamStrokeTableBody;
